<template>
  <v-snackbar v-model="snackbar"
    :top="true"
    :timeout="statusTimeout"
    :color="statusLevel"
    :multi-line="true">
    {{ statusMessage }}
    <v-btn text @click.stop.prevent="closeSnackbar">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "StatusSnackbar",
  data() {
    return {
      snackbar: false
    };
  },
  computed: {
    ...mapGetters(["statusMessage", "statusLevel", "statusTimeout"])
  },
  methods: {
    closeSnackbar(){
      this.snackbar = false;
    }
  },
  watch: {
    statusMessage() {
      if (this.statusMessage) this.snackbar = true;
      else this.snackbar = false;
    },
    snackbar(){
      if (!this.snackbar) this.$store.commit("destroyStatus");
    }
  }
};
</script>